import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface CredentialsStatus {
  isValid?: boolean;
}

export interface OAuthConnectResponse {
  authorizationUrl?: string;
}

export interface OAuthCallbackResponse {
  linked: boolean;
}

@Injectable()
export class CredentialsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.baseBackendUrl;

  checkCredentialsStatus(
    dataSourceProviderId: number,
  ): Observable<CredentialsStatus> {
    return this.http.get<CredentialsStatus>(
      `${this.baseUrl}/api/Credentials/status`,
      {
        params: { dataSourceProviderId: dataSourceProviderId.toString() },
      },
    );
  }

  oauthConnect(providerId: number): Observable<OAuthConnectResponse> {
    return this.http.get<OAuthConnectResponse>(
      `${this.baseUrl}/oauth/connect/${providerId}`,
    );
  }

  oauthCallback(
    code: string,
    state: string,
  ): Observable<OAuthCallbackResponse> {
    return this.http.get<OAuthCallbackResponse>(
      `${this.baseUrl}/oauth/callback`,
      {
        params: { code, state },
      },
    );
  }

  /** La credencial es siempre del usuario actual: el backend lo toma de la sesión. */
  createCredentials(data: {
    dataSourceProviderId: number;
    payload: Record<string, string>;
    authorized: boolean;
    authorizedAt: string;
  }): Observable<unknown> {
    return this.http.post(`${this.baseUrl}/api/Credentials`, data);
  }
}
